module.exports = __webpack_public_path__ + "static/img/8.6b03470.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/sp/8.png
// module id = NBvt
// module chunks = 0